import { Injectable, Signal, inject } from '@angular/core';
import { APP_ACTIONS, type AppActionsApi } from '@app/core/app.actions';
import { RxState } from '@rx-angular/state';
import { Bunker } from '@vessel-reports/noon/state/noon.types';

interface INoonState {
  detailNoonReport: any;
  previousReport: any;
  inventories: any[];
  detailBunker: Bunker;
  types: any[];
  voyages: any[];
  dateReport: any;
}

@Injectable({
  providedIn: 'root'
})
export class NoonState extends RxState<INoonState> {
  protected readonly appActions: AppActionsApi = inject(APP_ACTIONS);

  detailNoonReport: Signal<any> = this.signal('detailNoonReport');
  previousReport: Signal<any> = this.signal('previousReport');
  detailBunker: Signal<Bunker> = this.signal('detailBunker');
  types: Signal<any> = this.signal('types');
  voyages: Signal<any> = this.signal('voyages');
  dateReport: Signal<any> = this.signal('dateReport');

  constructor() {
    super();
    this.hold(this.appActions.resetAll$, () => {
      this.reset();
    });
    this.set({
      detailNoonReport: null,
      previousReport: null,
      inventories: [],
      detailBunker: null
    });
  }

  // Clear all noon report related state
  reset(): void {
    this.set({
      detailNoonReport: null,
      previousReport: null,
      inventories: [],
      detailBunker: null,
      types: [],
      voyages: [],
      dateReport: null
    });
  }
}
